export const REQUEST_EVENTO = 'REQUEST_EVENTO';
export const RECEIVE_EVENTO = 'RECEIVE_EVENTO';
export const EVENTO_NAO_ENCONTRADO = 'EVENTO_NAO_ENCONTRADO';

export const LOGIN_USER = 'LOGIN_USER';
export const UPDATE_USER = 'UPDATE_USER';

export const LOGOUT_USER = 'LOGOUT_USER';
export const ATUALIZA_MEUSDADOS = 'ATUALIZA_MEUSDADOS';
